import { Link } from "react-router-dom";
import { zones } from "@/mocks/zones";

const zoneIcons: Record<string, string> = {
  z1: "ri-tv-2-line",
  z2: "ri-emotion-happy-line",
  z3: "ri-movie-2-line",
  z4: "ri-mic-line",
  z5: "ri-chat-smile-2-line",
  z6: "ri-bar-chart-2-line",
};

export default function ChannelStrip() {
  return (
    <section aria-labelledby="channel-title" className="w-full bg-background-50 border-b border-background-200">
      <div className="w-full px-4 md:px-8 py-10 md:py-12">
        <div className="flex flex-wrap items-center justify-between gap-3 mb-6">
          <h2 id="channel-title" className="font-heading font-bold text-xl md:text-2xl text-foreground-950">
            频道快捷入口
          </h2>
          <Link
            to="/zones"
            className="text-sm text-primary-700 font-medium flex items-center gap-1 hover:gap-2 transition-all cursor-pointer"
          >
            全部 {zones.length} 个专区
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="flex gap-3 md:gap-4 overflow-x-auto no-scrollbar pb-1">
          {zones.map((zone) => (
            <Link
              key={zone.id}
              to={`/zone/${zone.id}`}
              className="group shrink-0 w-44 md:w-52 rounded-lg border border-background-200 bg-background-100 p-4 hover:border-primary-300 hover:bg-background-50 transition-colors cursor-pointer"
            >
              <span className="w-10 h-10 flex items-center justify-center rounded-md bg-background-50 text-primary-600 group-hover:bg-primary-600 group-hover:text-background-50 transition-colors">
                <i className={`${zoneIcons[zone.id] ?? "ri-layout-grid-line"} text-xl`}></i>
              </span>
              <p className="mt-3 font-heading font-semibold text-base text-foreground-950">
                {zone.name}
              </p>
              <p className="mt-1 text-xs text-foreground-500">{zone.subtitle}</p>
              <p className="mt-3 text-xs font-label text-secondary-700">{zone.count} 期合集</p>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}